/**
 * @generated SignedSource<<778fd35fe3129cdb3d79468cae5a74dc>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeliveryRequestStatus = "CANCELLED" | "FULFILLED" | "OPEN" | "%future added value";
export type HubStatus = "OFFLINE" | "ONLINE" | "%future added value";
export type SpaceConfiguration = "BACE_CLATTERING_STANDARD" | "BACE_SATELLITE_LARGE_EXTENDED" | "BACE_SATELLITE_LARGE_STANDARD" | "BACE_SATELLITE_MEDIUM_EXTENDED" | "BACE_SATELLITE_MEDIUM_STANDARD" | "BACE_SATELLITE_SMALL_EXTENDED" | "BACE_SATELLITE_SMALL_SLIM" | "BACE_SATELLITE_SMALL_STANDARD" | "BACE_STOREFRONT_2XL" | "BACE_STOREFRONT_L" | "BACE_STOREFRONT_M" | "BACE_STOREFRONT_S" | "BACE_STOREFRONT_XL" | "BACE_TRUCK_HUB_STANDARD" | "THALIA_RENZ_STANDARD_M" | "THALIA_RENZ_STANDARD_S" | "THALIA_RENZ_STANDARD_XS" | "THALIA_RENZ_WIDE_M" | "THALIA_RENZ_WIDE_S" | "%future added value";
export type deliver_spaceIdQuery$variables = {
  hubName: string;
  requestId: string;
  withRequest: boolean;
};
export type deliver_spaceIdQuery$data = {
  readonly deliveryRequest?: {
    readonly content: string;
    readonly hubId: string;
    readonly id: string;
    readonly requesterOrganization: {
      readonly id: string;
      readonly name: string;
    };
    readonly status: DeliveryRequestStatus;
  } | null | undefined;
  readonly hubMeta: {
    readonly city: string;
    readonly hub: {
      readonly availableConfigurations: ReadonlyArray<{
        readonly configuration: SpaceConfiguration;
        readonly spaces: ReadonlyArray<{
          readonly configuration: SpaceConfiguration;
          readonly frame: string;
          readonly id: string;
          readonly position: number;
        }>;
      }>;
      readonly id: string;
      readonly spaces: ReadonlyArray<{
        readonly frame: string;
      }>;
      readonly status: HubStatus;
    };
    readonly id: string;
    readonly name: string;
    readonly postalCode: string;
    readonly street: string;
  };
};
export type deliver_spaceIdQuery = {
  response: deliver_spaceIdQuery$data;
  variables: deliver_spaceIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "hubName"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "requestId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "withRequest"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "condition": "withRequest",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "requestId"
        }
      ],
      "concreteType": "DeliveryRequest",
      "kind": "LinkedField",
      "name": "deliveryRequest",
      "plural": false,
      "selections": [
        (v1/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hubId",
          "storageKey": null
        },
        (v2/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "content",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Organization",
          "kind": "LinkedField",
          "name": "requesterOrganization",
          "plural": false,
          "selections": [
            (v1/*:: as any*/),
            (v3/*:: as any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ]
},
v5 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "hubName"
      }
    ],
    "kind": "ObjectValue",
    "name": "by"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "street",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "city",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "postalCode",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "frame",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "configuration",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "Hub",
  "kind": "LinkedField",
  "name": "hub",
  "plural": false,
  "selections": [
    (v1/*:: as any*/),
    (v2/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Space",
      "kind": "LinkedField",
      "name": "spaces",
      "plural": true,
      "selections": [
        (v9/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AvailableSpaceConfiguration",
      "kind": "LinkedField",
      "name": "availableConfigurations",
      "plural": true,
      "selections": [
        (v10/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Space",
          "kind": "LinkedField",
          "name": "spaces",
          "plural": true,
          "selections": [
            (v1/*:: as any*/),
            (v9/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "position",
              "storageKey": null
            },
            (v10/*:: as any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v12 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "String"
},
v13 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "UUID"
},
v14 = {
  "enumValues": [
    "BACE_STOREFRONT_S",
    "BACE_STOREFRONT_M",
    "BACE_STOREFRONT_L",
    "BACE_STOREFRONT_XL",
    "BACE_STOREFRONT_2XL",
    "BACE_SATELLITE_SMALL_STANDARD",
    "BACE_SATELLITE_SMALL_SLIM",
    "BACE_SATELLITE_SMALL_EXTENDED",
    "BACE_SATELLITE_MEDIUM_STANDARD",
    "BACE_SATELLITE_MEDIUM_EXTENDED",
    "BACE_SATELLITE_LARGE_STANDARD",
    "BACE_SATELLITE_LARGE_EXTENDED",
    "BACE_CLATTERING_STANDARD",
    "BACE_TRUCK_HUB_STANDARD",
    "THALIA_RENZ_STANDARD_XS",
    "THALIA_RENZ_STANDARD_S",
    "THALIA_RENZ_STANDARD_M",
    "THALIA_RENZ_WIDE_S",
    "THALIA_RENZ_WIDE_M"
  ],
  "nullable": false,
  "plural": false,
  "type": "SpaceConfiguration"
},
v15 = {
  "enumValues": null,
  "nullable": false,
  "plural": true,
  "type": "Space"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deliver_spaceIdQuery",
    "selections": [
      (v4/*:: as any*/),
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v5/*:: as any*/),
          "concreteType": "HubMeta",
          "kind": "LinkedField",
          "name": "hubMeta",
          "plural": false,
          "selections": [
            (v1/*:: as any*/),
            (v3/*:: as any*/),
            (v6/*:: as any*/),
            (v7/*:: as any*/),
            (v8/*:: as any*/),
            {
              "kind": "RequiredField",
              "field": (v11/*:: as any*/),
              "action": "THROW"
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "deliver_spaceIdQuery",
    "selections": [
      (v4/*:: as any*/),
      {
        "alias": null,
        "args": (v5/*:: as any*/),
        "concreteType": "HubMeta",
        "kind": "LinkedField",
        "name": "hubMeta",
        "plural": false,
        "selections": [
          (v1/*:: as any*/),
          (v3/*:: as any*/),
          (v6/*:: as any*/),
          (v7/*:: as any*/),
          (v8/*:: as any*/),
          (v11/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9e2660db0cda3fd78f4851396ce08edd",
    "id": null,
    "metadata": {
      "relayTestingSelectionTypeInfo": {
        "deliveryRequest": {
          "enumValues": null,
          "nullable": true,
          "plural": false,
          "type": "DeliveryRequest"
        },
        "deliveryRequest.content": (v12/*:: as any*/),
        "deliveryRequest.hubId": (v13/*:: as any*/),
        "deliveryRequest.id": (v13/*:: as any*/),
        "deliveryRequest.requesterOrganization": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "Organization"
        },
        "deliveryRequest.requesterOrganization.id": (v13/*:: as any*/),
        "deliveryRequest.requesterOrganization.name": (v12/*:: as any*/),
        "deliveryRequest.status": {
          "enumValues": [
            "OPEN",
            "FULFILLED",
            "CANCELLED"
          ],
          "nullable": false,
          "plural": false,
          "type": "DeliveryRequestStatus"
        },
        "hubMeta": {
          "enumValues": null,
          "nullable": true,
          "plural": false,
          "type": "HubMeta"
        },
        "hubMeta.city": (v12/*:: as any*/),
        "hubMeta.hub": {
          "enumValues": null,
          "nullable": true,
          "plural": false,
          "type": "Hub"
        },
        "hubMeta.hub.availableConfigurations": {
          "enumValues": null,
          "nullable": false,
          "plural": true,
          "type": "AvailableSpaceConfiguration"
        },
        "hubMeta.hub.availableConfigurations.configuration": (v14/*:: as any*/),
        "hubMeta.hub.availableConfigurations.spaces": (v15/*:: as any*/),
        "hubMeta.hub.availableConfigurations.spaces.configuration": (v14/*:: as any*/),
        "hubMeta.hub.availableConfigurations.spaces.frame": (v12/*:: as any*/),
        "hubMeta.hub.availableConfigurations.spaces.id": (v13/*:: as any*/),
        "hubMeta.hub.availableConfigurations.spaces.position": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "Int"
        },
        "hubMeta.hub.id": (v13/*:: as any*/),
        "hubMeta.hub.spaces": (v15/*:: as any*/),
        "hubMeta.hub.spaces.frame": (v12/*:: as any*/),
        "hubMeta.hub.status": {
          "enumValues": [
            "ONLINE",
            "OFFLINE"
          ],
          "nullable": false,
          "plural": false,
          "type": "HubStatus"
        },
        "hubMeta.id": (v13/*:: as any*/),
        "hubMeta.name": (v12/*:: as any*/),
        "hubMeta.postalCode": (v12/*:: as any*/),
        "hubMeta.street": (v12/*:: as any*/)
      }
    },
    "name": "deliver_spaceIdQuery",
    "operationKind": "query",
    "text": "query deliver_spaceIdQuery(\n  $hubName: String!\n  $requestId: UUID!\n  $withRequest: Boolean!\n) {\n  deliveryRequest(id: $requestId) @include(if: $withRequest) {\n    id\n    hubId\n    status\n    content\n    requesterOrganization {\n      id\n      name\n    }\n  }\n  hubMeta(by: {name: $hubName}) {\n    id\n    name\n    street\n    city\n    postalCode\n    hub {\n      id\n      status\n      spaces {\n        frame\n      }\n      availableConfigurations {\n        configuration\n        spaces {\n          id\n          frame\n          position\n          configuration\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4af1d802f689bf22c1bae492d5bd5197";

export default node;
